// src/user/SolicitarResetPassword.jsx
import React, { useState } from "react";
import { Global } from "../helpers/Global";

// ✅ Toast
import { useToast } from "../hooks/useToast";

// ===== MUI =====
import {
  Box,
  Paper,
  Typography,
  Stack,
  TextField,
  Button,
  InputAdornment,
} from "@mui/material";

// Icons
import EmailIcon from "@mui/icons-material/Email";

export const SolicitarResetPassword = () => {
  // =========================
  // Estado
  // =========================
  const toast = useToast();

  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  // =========================
  // Submit
  // =========================
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;

    if (!email) {
      toast.warning("Por favor, introduce tu correo electrónico.");
      return;
    }

    setIsSubmitting(true);

    try {
      const endpoint = `${Global.url}usuarios/password/reset/request`;
      const payload = {
        email: email.trim().toLowerCase(),
        baseUrl: window.location.origin,
      };

      const res = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        toast.error(data?.message || "No se pudo procesar la solicitud.");
        return;
      }

      toast.success(data?.message || "Revisa tu correo para continuar.");
      setEmail("");
    } catch (error) {
      console.error("Error al solicitar reseteo:", error);
      toast.error("Error al procesar la solicitud.");
    } finally {
      setIsSubmitting(false);
    }
  };

  // =========================
  // Render
  // =========================
  return (
    <Box className="appContainer">
      <Stack spacing={2}>
        {/* Cabecera */}
        <Box className="pageHeader">
          <Typography variant="h5" sx={{ fontWeight: 700 }}>
            ¿Olvidaste tu contraseña?
          </Typography>

          <Typography sx={{ fontSize: 14, color: "text.secondary" }}>
            Introduce tu correo electrónico y te enviaremos un enlace para restablecerla.
          </Typography>
        </Box>

        {/* ✅ Formulario single-column semántico */}
        <Box className="contentContainer contentContainer--formSingle">
          <Paper sx={{ p: 2 }}>
            <Box component="form" onSubmit={handleSubmit}>
              <Stack spacing={2}>
                {/* Email */}
                <TextField
                  type="email"
                  label="Email"
                  placeholder="usuario@dominio.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoComplete="email"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <EmailIcon fontSize="small" />
                      </InputAdornment>
                    ),
                  }}
                />

                {/* Acción */}
                <Button
                  type="submit"
                  disabled={isSubmitting}
                  aria-busy={isSubmitting}
                  sx={{ height: 40 }}
                >
                  {isSubmitting ? "Enviando..." : "Enviar enlace"}
                </Button>
              </Stack>
            </Box>
          </Paper>
        </Box>
      </Stack>
    </Box>
  );
};
